// src/utils/pincodeService.js
import { 
  getNearbyPincodes as getNearbyPincodesFromData, 
  debugNearbyPincodes, 
  DELHI_PINCODES 
} from '../data/delhiPincodes';

// Get nearby pincodes with console logging
export const getNearbyPincodes = async (pincode, radiusKm = 5) => {
  console.log(`\n🚀 getNearbyPincodes called with: pincode=${pincode}, radius=${radiusKm}km`);
  
  // Run debug to see what's happening
  const debugResults = debugNearbyPincodes(pincode, radiusKm);
  
  const results = getNearbyPincodesFromData(pincode, radiusKm);
  
  console.log(`📦 Returning ${results.length} pincodes:`, results);
  
  return results;
};

// Check if pincode exists in Delhi
export const isValidDelhiPincode = (pincode) => {
  const isValid = !!DELHI_PINCODES[pincode];
  console.log(`🔎 Pincode ${pincode} exists in Delhi database: ${isValid}`);
  return isValid;
};

// Get distance between two pincodes with logging
export const getDistanceBetweenPincodes = (pincode1, pincode2) => {
  const p1 = DELHI_PINCODES[pincode1];
  const p2 = DELHI_PINCODES[pincode2];
  if (!p1 || !p2) {
    console.log(`⚠️ Could not calculate distance: ${pincode1} or ${pincode2} not found`);
    return null;
  }
  
  const R = 6371;
  const dLat = (p2.lat - p1.lat) * Math.PI / 180;
  const dLon = (p2.lng - p1.lng) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) *
            Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  const distance = R * c;
  
  console.log(`📏 Distance between ${pincode1} and ${pincode2}: ${distance.toFixed(2)}km`);
  return distance;
};